import { Col, Container, Row } from "react-bootstrap";

export const Simple = () => {
  return (
    <section className="simple" id="simple">
      <Container>
        <Row className="align-items-center">
          <Col>
            <p>
              It's <span style={{ color: "#306AFF" }}>Simple.</span> We{" "}
              <span style={{ color: "#306AFF" }}>help</span> international
              patients seeking medical treatment in India with{" "}
              <span style={{ color: "#306AFF" }}>prompt, affordable,</span> and
              real-time
              <span style={{ color: "#306AFF" }}>assistance</span> every step of
              the way.
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
};
